import { render, staticRenderFns } from "./VueResultControl.vue?vue&type=template&id=07356814&scoped=true&"
import script from "./VueResultControl.vue?vue&type=script&lang=js&"
export * from "./VueResultControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07356814",
  null
  
)

export default component.exports